/**
 * Logger service - prints logs in development, silent in production.
 */
const isProduction = process.env.NODE_ENV === 'production';

const Logger = {
    log: (...args) => {
        if (!isProduction) {
            console.log(...args);
        }
    },
    info: (...args) => {
        if (!isProduction) {
            console.info(...args);
        }
    },
    warn: (...args) => {
        if (!isProduction) {
            console.warn(...args);
        }
    },
    error: (...args) => {
        if (!isProduction) {
            console.error(...args);
        }
    },
    debug: (...args) => {
        if (!isProduction) {
            console.debug(...args);
        }
    }
};

export default Logger;
